module.exports = __webpack_public_path__ + "9407f5c21eaecf553830314707b537d5.png";